<div class="selector-areaofinterests" data-cy="areaOfInterests">

  <app-loader *ngIf="isLoading()"></app-loader>

  <div *ngIf="!isLoading() && selectableAreaOfInterests().length > 0">

    <div class="alert alert-info" *ngIf="maxAmount">
      {{ 'Selected' | translate }}: {{ value ? value.length : 0}} / {{ maxAmount}}
    </div>

    <div class="form-group">
      <div class="input-group">
        <input [placeholder]="'Search' | translate" class="form-control" type="text" [(ngModel)]="searchTerm" (ngModelChange)="applySearchFilter()"/>
        <div class="input-group-append">
          <button class="btn btn-secondary" (click)="resetSearch()">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
        </div>
      </div>

    </div>

    <div class="mb-3" *ngIf="availableTags().length > 0">
      <button *ngFor="let tag of availableTags()"
        class="btn btn-sm mr-2 mb-1"
        [ngClass]="{'btn-primary': activeFilterTags().has(tag.name!), 'btn-outline-secondary': !activeFilterTags().has(tag.name!)}"
        (click)="toggleFilterTag(tag.name!)">
        {{ tag.name }} <span class="badge badge-light ml-1">{{ tagCounts().get(tag.name!) }}</span>
      </button>
    </div>

    <div class="row">
      <div class="col-12 col-lg-4 col-sm-6" [ngClass]="{'d-none': useSearch && !containsSearchTerm(interest)}" *ngFor="let interest of filteredAreaOfInterests()">

       <div>

         <div class="d-flex flex-row align-items-center mb-2">

           <button (click)="toggle(interest)" style="min-width: 0" class="btn flex-grow-1 flex-shrink-1 text-truncate" [ngClass]="{'btn-primary': exists(interest), 'btn-outline-secondary': !exists(interest)}">
             {{ interestService.getTranslatedName(interest) }}
           </button>

           <div class="px-2 flex-shrink-0 cursor-pointer d-flex align-items-center justify-content-center" [ngbTooltip]="interestService.getTranslatedName(interest) + '' + (interestService.getTranslatedDescription(interest) ? ' - ' + interestService.getTranslatedDescription(interest) : '')" [placement]="'bottom-right'">
             <div class="icon">
               <fa-icon [icon]="faInfoCircle" class="text-gray"></fa-icon>
             </div>
           </div>

         </div>

       </div>

      </div>
    </div>

  </div>

</div>
